import { createTypedChart } from "vue-chartjs"
import { LineController } from "chart.js"
import { useThemeHelper } from "@/theme/themeHelper"

class LineChartWithOriginController extends LineController {
  static override id = "line-with-origin"
  public override draw() {
    super.draw()

    const ctx = this.chart.ctx
    const right = this.chart.scales.x.right
    const left = this.chart.scales.x.left
    const origin = this.chart.scales.y.getPixelForValue(0)

    ctx.save()
    ctx.beginPath()
    ctx.moveTo(left, origin)
    ctx.lineTo(right, origin)
    ctx.lineWidth = 1
    ctx.strokeStyle = useThemeHelper().colors.value["on-background"]
    ctx.stroke()
    ctx.restore()
  }
}

const LineChartWithOrigin = createTypedChart(
  "line-with-origin" as "line",
  LineChartWithOriginController,
)

export default LineChartWithOrigin
